<template>
  <b-form id="information" @submit.prevent="onNextButton">
    <b-card no-body class="mb-1 px-3">
      <b-row>
        <b-col>
          <div class="form-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-between">
              <div>
                <global-button
                  text-class="secondary-text"
                  custom-class="secondary-border default-btn ml-1"
                  :btn-label="'Back'"
                  @click.native="onBackButton"
                />
              </div>
              <div>
                <global-button
                  v-if="formData.status == 1"
                  text-class="primary-text"
                  custom-class="primary-border default-btn ml-1"
                  :btn-label="'Save'"
                  @click.native="onSaveChange"
                />
                <global-button
                  v-if="!isConfirm"
                  :type="'submit'"
                  custom-class="next-btn text-white ml-1"
                  :btn-label="'Next'"
                  :loading="loading.save"
                />
                <global-button
                  v-if="isConfirm && formData.status == 1"
                  text-class="text-reject"
                  custom-class="border-danger btn-reject default-btn ml-1"
                  :btn-label="'Reject'"
                  icon-left="XIcon"
                  iconClass="icon-wrp-reject mr-2"
                  :loading="loading.reject"
                  loading-class="text-danger"
                  @click.native="openRejectModal"
                />
                <global-button
                  v-if="isConfirm && formData.status == 1"
                  custom-class="approve-btn text-white ml-1"
                  :btn-label="'Approve'"
                  icon-left="CheckIcon"
                  iconClass="icon-wrp-approve mr-2"
                  :loading="loading.approve"
                  @click.native="onApproveButton"
                />
                <global-button
                  v-if="isConfirm && formData.status !== 1"
                  text-class="text-white"
                  custom-class="danger-btn ml-1"
                  :btn-label="'Cancel'"
                  loading-class="text-white"
                  :loading="loading.cancelProcess"
                  @click.native="onCancelApproveButton"
                />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="7" class="overflow-scroll h-610px">
          <b-row>
            <b-col>
              <b-card-header class="px-0 py-0 mt-1">
                <div class="font-large-1 font-weight text-black">
                  <span>Document Detail</span>
                </div>
              </b-card-header>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="6">
              <label class="font-medium-5 font-weight text-black"
                >Customer Information</label
              >
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="6">
              <label class="font-medium-4 font-weight text-black">Status</label>
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="CircleIcon"
                  class="mr-2 status-icon"
                  :class="resolveStatusClass(formData.status)"
                />
                <span class="font-medium-4 font-weight text-black">{{
                  formData.statusLabel
                }}</span>
              </div>
            </b-col>
            <b-col
              cols="6"
              v-if="formData.rejectReason && formData.status == 9"
            >
              <b-form-group
                :label="'Reject Reason'"
                label-for="rejectReason"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="rejectReason"
                  disabled
                  v-model="formData.rejectReason"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="6">
              <b-form-group
                :label="'Customer Name'"
                label-for="customerName"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="customerName"
                  disabled
                  v-model="formData.customerName"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="'Mobile No.'"
                label-for="mobileNo"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="mobileNo"
                  v-model="formData.mobileNo"
                  disabled
                  @input="onNumberInput($event, 'mobileNo')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div class="divide mt-1"></div>
          <b-row class="mt-1">
            <b-col cols="6">
              <label class="font-medium-5 font-weight text-black"
                >Point and Spending</label
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <div class="font-medium-5 required">Total Point</div>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="totalPoint"
                  v-model="formData.totalPoint"
                  @input="onNumberInput($event, 'totalPoint')"
                  :disabled="isConfirm"
                  placeholder="ระบุ"
                  required
                />
                <b-input-group-append
                  is-text
                  class="add-on-border"
                  :class="isConfirm ? 'disabled-append' : ''"
                >
                  <div>Point</div>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <!-- point earn -->
            <!-- <b-col cols="6">
              <div class="font-medium-5">
                Point Earn <span class="text-desc">(Sum:Total Point) </span>
                <Strong class="text-black">คูณ 2</Strong>
              </div>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="pointEarn"
                  v-model="formData.pointEarn"
                  @input="onNumberInput($event, 'pointEarn')"
                  disabled
                />
                <b-input-group-append
                  is-text
                  class="add-on-border disabled-append"
                >
                  <div>Point</div>
                </b-input-group-append>
              </b-input-group>
            </b-col> -->
          </b-row>
          <b-row class="mt-1 mb-2">
            <b-col cols="6">
              <div class="font-medium-5 required">Total Spending</div>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="totalSpending"
                  v-model="formData.totalSpending"
                  @input="onNumberInput($event, 'totalSpending')"
                  :disabled="isConfirm"
                  placeholder="ระบุ"
                  required
                />
                <b-input-group-append
                  is-text
                  class="add-on-border"
                  :class="isConfirm ? 'disabled-append' : ''"
                >
                  <div>Bath</div>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <div class="divide mt-1"></div>
          <b-row class="mt-1">
            <b-col cols="6">
              <label class="font-medium-5 font-weight text-black"
                >Document Information</label
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                :label="'Document No'"
                label-for="docNo"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="docNo"
                  v-model="formData.docNo"
                  :disabled="isConfirm"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="'Receipt No (เลขที่ใบเสร็จ)'"
                label-for="receiptNo"
                label-class="font-medium-5 required"
              >
                <b-form-input
                  id="receiptNo"
                  v-model="formData.receiptNo"
                  :disabled="isConfirm"
                  placeholder="ตัวอย่าง ZKNVGFDA16ZKWP2G99"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                :label="'Document Type'"
                label-for="docType"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="docType"
                  v-model="formData.docTypeLabel"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="'Store Name'"
                label-for="storeName"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="storeName"
                  v-model="formData.storeName"
                  :disabled="isConfirm"
                  placeholder="ระบุ"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                :label="'Document Date (วันที่ซื้อสินค้า)'"
                label-for="docDate"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="docDate"
                  v-model="formData.docDate"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="'Date Time (วันที่อัพโหลดใบเสร็จ)'"
                label-for="dateTime"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="dateTime"
                  v-model="formData.dateTime"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                :label="'Remark 1'"
                label-for="remark1"
                label-class="font-medium-5"
              >
                <b-form-textarea
                  id="remark1"
                  v-model="formData.remark1"
                  no-resize
                  rows="2"
                  placeholder="ระบุ"
                  :disabled="isConfirm"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="'Remark 2'"
                label-for="remark2"
                label-class="font-medium-5"
              >
                <b-form-textarea
                  id="remark2"
                  v-model="formData.remark2"
                  no-resize
                  rows="2"
                  placeholder="ระบุ"
                  :disabled="isConfirm"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div class="divide mt-1"></div>
          <b-row class="mt-1">
            <b-col cols="6">
              <label class="font-medium-5 font-weight text-black"
                >Interface / 3rd Party Data</label
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group
                :label="'ITF Ref.'"
                label-for="itfRef1"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="itfRef1"
                  v-model="formData.itfRef1"
                  placeholder="ระบุ"
                  :disabled="isConfirm"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="'ITF Ref. 2'"
                label-for="itfRef2"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="itfRef2"
                  v-model="formData.itfRef2"
                  placeholder="ระบุ"
                  :disabled="isConfirm"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="6">
              <b-form-group
                :label="'ITF Extra Data'"
                label-for="itfRefExtra"
                label-class="font-medium-5"
              >
                <b-form-textarea
                  id="itfRefExtra"
                  v-model="formData.itfExtra"
                  no-resize
                  rows="3"
                  placeholder="ระบุ"
                  :disabled="isConfirm"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div
            class="divide mt-1"
            v-if="formData.information.payload.length > 0"
          ></div>
          <b-row class="mt-1" v-if="formData.information.payload.length > 0">
            <b-col cols="6">
              <label class="font-medium-5 font-weight text-black">Other</label>
            </b-col>
          </b-row>
          <b-row
            v-for="(field, index) in formData.information.payload"
            :key="`row-${field.key + index}`"
            :class="index > 0 ? 'mt-1' : null"
          >
            <b-col cols="12" v-if="field.type_id == 19">
              <label
                :for="`input-${field.key}`"
                class="style-hander"
                :class="field.required ? 'required' : null"
              >
                {{ $i18n.locale == "th" ? field.label_th : field.label_en }}
              </label>
              <v-select
                v-model="field.optionid"
                class="select-format-container font-medium-5 bg-dropdown"
                :options="field.opt_fields"
                :reduce="(option) => option.value"
                :clearable="false"
                :placeholder="'Please Select'"
                :disabled="isConfirm"
              />
            </b-col>
            <b-col
              cols="12"
              v-else-if="field.type_id != 20 && field.type_id != 21"
            >
              <component
                :is="resolveFields(field)"
                :ref="`${field.key + index}`"
                :key="field.key"
                :class="[isConfirm ? 'input-disabled' : '']"
                :field-properties="field"
              />
            </b-col>
            <b-col
              cols="12"
              v-if="
                (field.type_id == 20 || field.type_id == 21) &&
                  field.isdelete == false
              "
            >
              <b-row>
                <b-col cols="5">
                  <label
                    :for="`input-${field.key}`"
                    class="style-hander"
                    :class="field.required ? 'required' : null"
                  >
                    {{ $i18n.locale == "th" ? field.label_th : field.label_en }}
                  </label>
                  <v-select
                    v-model="field.optionid"
                    class="select-format-container font-medium-5 bg-dropdown"
                    :options="field.opt_fields"
                    :reduce="(option) => option.value"
                    :clearable="false"
                    :placeholder="'Please Select'"
                    :disabled="isConfirm"
                  />
                </b-col>
                <b-col cols="6">
                  <label class="style-hander">
                    {{ "Value" }}
                  </label>
                  <b-input
                    :ref="`${field.key + index}`"
                    :id="`input-${field.key}`"
                    v-model="field.value"
                    :type="field.type_id == 20 ? 'text' : 'number'"
                    :step="field.type_id == 20 ? '' : '0.01'"
                    placeholder="ระบุ"
                    :disabled="isConfirm"
                  />
                </b-col>
                <b-col
                  v-if="
                    dynamicDropdownCondition(field, 'checkcount') > 1 &&
                      !isConfirm
                  "
                  cols="1"
                  class="d-flex align-items-end custom-delete-dropdown"
                >
                  <b-button
                    class="delete-dropdown"
                    v-b-tooltip.hover
                    @click="onRemoveDropDown(field, index)"
                  >
                    <delete-icon class="svg-delete-icon" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row
                v-if="
                  dynamicDropdownCondition(field, 'lastfield') && !isConfirm
                "
              >
                <b-col cols="11" class="d-flex justify-content-end">
                  <b-button
                    class="add-dropdown-value"
                    @click="onAddDropDown(field, index)"
                  >
                    <div>
                      <icon-plus class="svg-plus-icon" />
                    </div>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br v-if="formData.information.payload.length > 0" />
        </b-col>
        <b-col cols="5">
          <b-row>
            <b-col>
              <preview-image :image-list="formData.imageList" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <document-confirm-modal
      v-if="modalType.confirm"
      :form-data-obj="formData"
      @onSubmit="saveConfirmModal"
      @onCloseModal="closeConfirmModal"
    />
    <reject-reason-modal
      v-if="modalType.reject"
      :form-data-obj="formData"
      :OptionReject="rejecOptionData"
      @onReject="onReject"
      @onCloseModal="closeRejectModal"
    />
  </b-form>
</template>

<script>
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue"
import Textbox from "@/views/components/dynamic-fields/components/TextBoxField.vue"
import TextAreaField from "@/views/components/dynamic-fields/components/TextAreaField.vue"
import Dropdown from "@/views/components/dynamic-fields/components/DropdownField.vue"
import DatePicker from "@/views/components/dynamic-fields/components/DatePickerField.vue"
import ImagePreviewList from "@/views/components/image-preview-list/ImagePreviewList.vue"
import DocumentConfirmModal from "./DocumentConfirmModal.vue"
import useDocumentInformation from "../hooks/useDocumentInformation"
import RejectReasonModal from "../components/RejectReasonModal.vue"
import PreviewImage from "../../components/PreviewImage.vue"
import DeleteIcon from "@/@core/components/svg/common/Trash.vue"
import IconPlus from "@core/components/svg/common/IconPlus.vue"

export default {
  components: {
    Toggle,
    Textbox,
    TextAreaField,
    Dropdown,
    DatePicker,
    ImagePreviewList,
    DocumentConfirmModal,
    RejectReasonModal,
    PreviewImage,
    DeleteIcon,
    IconPlus,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    documentId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      formData,
      isConfirm,
      loading,
      modalType,
      resolveFields,
      resolveStatusLabel,
      resolveStatusClass,
      onNextButton,
      onCancelButton,
      onBackButton,
      onApproveButton,
      onRejectButton,
      onCancelApproveButton,
      openConfirmModal,
      closeConfirmModal,
      saveConfirmModal,
      onSaveChange,
      onNumberInput,
      rejecOptionData,
      onReject,
      openRejectModal,
      closeRejectModal,
      fetchDocumentDetailFunc,
      onRemoveDropDown,
      onAddDropDown,
      dynamicDropdownCondition,
    } = useDocumentInformation(props)

    return {
      formData,
      isConfirm,
      loading,
      modalType,
      resolveFields,
      resolveStatusLabel,
      resolveStatusClass,
      onNextButton,
      onCancelButton,
      onBackButton,
      onApproveButton,
      onRejectButton,
      onCancelApproveButton,

      openConfirmModal,
      closeConfirmModal,
      saveConfirmModal,
      onSaveChange,
      onNumberInput,

      rejecOptionData,
      onReject,
      openRejectModal,
      closeRejectModal,
      fetchDocumentDetailFunc,
      onRemoveDropDown,
      onAddDropDown,
      dynamicDropdownCondition,
    }
  },
}
</script>

<style>
@import "~@/assets/css/pages/document-detail/information.css";
</style>
